import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BreadCumb, DataTables, NavBar, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import $ from "jquery";
import moment from "moment";

let apiClient = ApiClient.getInstance();

const headersDataTableOPQT = [
    { title: "Serie", value: true },
    { title: "Num.Doc", value: true },
    { title: "Proveedor", value: true },
    { title: "Nombre", value: true },
    { title: "Fecha Cont.", value: true },
    { title: "Empl. Compras", value: true },
    { title: "Titular Doc.", value: true },
    { title: "Fecha Necesaria", value: true },
    { title: "Comentarios", value: true },
    { title: "Total", value: true },
    { title: "Estatus", value: true }];


const headersDataTableOWTQ = [ // Nota: Si se modifican estos modificar igual los de TransfersRequestView
    { title: "Serie", value: true },//0
    { title: "Num.Doc", value: true },//1
    { title: "Estatus", value: true },//2
    { title: "Cliente", value: true },//3
    { title: "Nombre", value: true },//4
    { title: "De Almacén", value: true },//5
    { title: "Almacén destino", value: true },//6
    { title: "Tipo de Salida del Documento", value: true },//7
    { title: "Centro de Costo (CeCo)", value: true },//8
    { title: "Fecha Cont.", value: true },//9
    { title: "Empl. Ventas", value: true },//10
    { title: "Comentarios", value: true },//11
    { title: "Total", value: true },//12
    { title: "Observacion del Estado", value: true },//13
    { title: "Estado del documento", value: true }//14
];

const headersDataTableOPOR = [
    { title: "Serie", value: true },
    { title: "Num.Doc", value: true },
    { title: "Solicitud de Compra", value: true },
    { title: "Proveedor", value: true },
    { title: "Nombre", value: true },
    { title: "Fecha Cont.", value: true },
    { title: "Empl. Compras", value: true },
    { title: "Titular Doc.", value: true },
    { title: "Comentarios", value: true },
    { title: "Total", value: true },
    { title: "Estatus", value: true },
    { title: "Áreas", value: true },
    { title: "Lugar Entrega", value: true },
    { title: "Planta", value: true },
    { title: "Usuario Gen. OC", value: true },
    { title: "Nivel Orden", value: true },
    { title: "Proyecto", value: true },
    { title: "Sucursal", value: true },
    { title: "Departamento", value: true },
    { title: "Borrador origen", value: false },
    { title: "F. Creado borr.", value: false },
    { title: "F. Creado firme", value: false },
];

class DraftView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTableOPQT,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            DraftObjType: '540000006',
        }

    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liFacturaAuth");
        let today = moment(new Date()).format('YYYYMMDD');

        let date = {
            dateInit: today,
            dateFinal: today,
        }

        await this.callDocumentsListService(date);
    }

    selectValidateSeries = (table, data, docSubType) => {
        let series = "";
        switch (table) {
            case '23':
                series = data.U_FMB_ValidateSeriesOQUT || "";
                break;
            case '17':
                series = data.U_FMB_ValidateSeriesORDR || "";
                break;
            case '15':
                series = data.U_FMB_ValidateSeriesODLN || "";
                break;
            case '13':
                if (docSubType === "--") {
                    series = data.U_FMB_ValidateSeriesOINV || "";
                } else {
                    series = data.U_FMB_ValidateSeriesDN || "";
                }
                break;
            case '203':
                series = data.U_FMB_ValidateSeriesODPI || "";
                break;
            case '16':
                series = data.U_FMB_ValidateSeriesORDN || "";
                break;
            case '18':
                if (docSubType === "--") {
                    series = data.U_FMB_ValidateSeriesOPCH || "";
                } else {
                    series = data.U_FMB_ValidateSeriesDM || "";
                }
                break;
            case '19':
                series = data.U_FMB_ValidateSeriesORPC || "";
                break;
            case '24':
                series = data.U_FMB_ValidateSeriesORCT || "";
                break;
            case '21':
                series = data.U_FMB_ValidateSeriesORPD || "";
                break;
            case '67':
                series = data.U_FMB_ValidateSeriesOWTR || "";
                break;
            case '14':
                series = data.U_FMB_ValidateSeriesORIN || "";
                break;
            case '1250000001':
                series = data.U_FMB_ValidateSeriesOWTQ || "";
                break;
            case '59':
                series = data.U_FMB_ValidateSeriesOIGN || "";
                break;
            case '60':
                series = data.U_FMB_ValidateSeriesOIGE || "";
                break;
            case '22':
                series = data.U_FMB_ValidateSeriesOPOR || "";
                break;
            case '204':
                series = data.U_FMB_ValidateSeriesODPO || "";
                break;
            case '20':
                series = data.U_FMB_ValidateSeriesOPDN || "";
                break;
            case '1470000113':
                series = data.U_FMB_ValidateSeriesOPRQ || "";
                break;
            case '162':
                series = data.U_FMB_ValidateSeriesOMRV || "";
                break;
            case '540000006':
                series = data.U_FMB_ValidateSeriesOPQT || "";
                break;
            default:
                series = "";
        }

        return { series }
    };

    callDocumentsListService = async newDate => {
        const { enableSpinner } = this.props;
        const { DraftObjType } = this.state;

        // let docType = $('#selectDocTypeDocumentSearch').val();
        let docType = DraftObjType;


        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || {};
        const data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            docSubTypeDraft: docType,
            user_Email: user.E_Mail,
            table: "MODRF",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--'
        };

        enableSpinner(true);
        let draftListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);


        if (draftListResponse.status === SERVICE_RESPONSE.SUCCESS) {

            const dataSerie = {
                docType: docType,
            };

            enableSpinner(true);
            const seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);
            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
            let ValidateSeries = this.selectValidateSeries(docType, user, '');

            if (!user || ValidateSeries.series === "") {
                this.setState({
                    data: [],
                });
                return;
            }
            let seriesUsers = ValidateSeries.series.split("|");
            let newArraySeries = [];

            for (let index = 0; index < seriesUsers.length; index++) {
                const serieUser = seriesUsers[index];
                for (let index = 0; index < seriesResponse.data.length; index++) {
                    const serieResponse = seriesResponse.data[index];
                    if (String(serieResponse.Series) === String(serieUser)) {
                        newArraySeries.push(serieResponse);
                    }
                }
            }

            if (newArraySeries.length === 0) {
                return;
            }

            let newDocumentsfilterSeries = [];
            for (let index = 0; index < draftListResponse.data.length; index++) {
                const document = draftListResponse.data[index];
                for (let index = 0; index < newArraySeries.length; index++) {
                    const serie = newArraySeries[index];
                    if (String(document.SeriesCode) === String(serie.Series)) {
                        newDocumentsfilterSeries.push(document);
                    }
                }
            }


            this.setState({
                data: newDocumentsfilterSeries,
            });
            return;
        } else {
            this.setState({
                data: [],
            });
        }

    }

    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };

    changeDraftObjType = (objType, date) => {
        const headersByObjType = { '540000006': headersDataTableOPQT, '22': headersDataTableOPOR, '1250000001': headersDataTableOWTQ, };
        return new Promise((resolve) => {
            this.setState(
                {
                    DraftObjType: objType,
                    data: [],
                    headers: headersByObjType[String(objType)] || headersDataTableOPQT,
                },
                () => {
                    resolve();
                }
            );
        });
    };

    render() {
        const { headers, data, _user, DraftObjType } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={'DOCUMENTOS PRELIMINARES'} url1={'#'} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <span id="draftView" className="text-muted">
                            &nbsp;DOCUMENTOS PRELIMINARES
                        </span>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"draft"}
                        data={data}
                        search={this.searchDocuments}
                        DraftObjType={DraftObjType}
                        changeDraftObjType={this.changeDraftObjType}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DraftView);


